var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-variables"},_vm._l((_vm.variables),function(variable){return _c('div',{staticClass:"single-variable"},[_c('pc-single-variable',{attrs:{"variable":variable}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }